import { memo, useCallback, useEffect } from "react";
import Modal from "react-modal";
import PropTypes from "prop-types";
import { FLIGHT_OPTIONS_STATUS, INSURANCE_STANDARD } from "app/constants";
import FlexRateFlex from "app/pages/Booking/Quotation/FlexRate/FlexRateFlex";
import { calculateFlexIncluded } from "app/utils/quotationUtils";
import "./FlexRateModal.scss";
import useBlockViewportScroll from "app/pages/.shared/useBlockViewportScroll";
import { sendTagOnQuotationFlex, sendTagOnQuotationFlexSelect } from "app/utils/analytics";

const style = {
	overlay: {
		backgroundColor: "rgba(43, 56, 63, .9)",
		zIndex: 6, // 6 to be above holiday summary
	},
};

export const FlexRateModal = ({
	isOpened = false,
	quotation,
	submitting,
	handleSubmit,
	total,
	nbPassengers,
	updateBooking,
	showFlexRatesModal = () => {},
}) => {
	let flexInsurances = [];

	if (quotation.insurances) {
		flexInsurances = quotation.insurances.insurancesItem;
	}

	useBlockViewportScroll(isOpened);

	const handleFlexRatesClose = useCallback(() => {
		showFlexRatesModal(false);
	}, []);

	const handleClick = insurance => {
		updateBooking({
			insuranceFlex: { ...insurance, upgradePrice: totalFlex - total },
			insurance: {},
		});
		sendTagOnQuotationFlexSelect({
			flex: {
				standard_price: total,
				flex_price: totalFlex,
				flex_selected: isAssuranceFLex(insurance),
			},
		});
		handleSubmit();
	};

	const getTotalFlex = insuranceItem => {
		const flexIncluded = calculateFlexIncluded(insuranceItem, total, nbPassengers);
		return total + flexIncluded;
	};

	const isAssuranceFLex = insurance => insurance.code !== INSURANCE_STANDARD;

	// ATTENTION partie assurance flex à retravailler si plus d'une assurance
	const totalFlex = flexInsurances
		? getTotalFlex(flexInsurances.find(insurance => isAssuranceFLex(insurance)))
		: 0;

	useEffect(() => {
		if (isOpened) {
			sendTagOnQuotationFlex({
				flex: { standard_price: total, flex_price: totalFlex },
			});
		}
	}, [isOpened]);

	return (
		<Modal
			style={style}
			isOpen={isOpened}
			onRequestClose={handleFlexRatesClose}
			className="flexrate__modal"
			overlayClassName="flexrate__overlay"
		>
			<div className="flexrate" data-testid="flex-rate-modal">
				<div className="flexrate__close" onClick={handleFlexRatesClose}>
					<i className="icon icon--cross-dark" />
				</div>

				<div className="flexrate__rates">
					{flexInsurances &&
						flexInsurances.map(insurance => {
							return (
								<FlexRateFlex
									key={insurance.name}
									insurance={insurance}
									disabled={
										submitting ||
										quotation.flightOptionsStatus ===
											FLIGHT_OPTIONS_STATUS.LOADING
									}
									loading={
										submitting ||
										quotation.flightOptionsStatus ===
											FLIGHT_OPTIONS_STATUS.LOADING
									}
									handleClick={handleClick}
									total={totalFlex}
									upgradePrice={totalFlex - total}
								/>
							);
						})}
				</div>
			</div>
		</Modal>
	);
};

FlexRateModal.propTypes = {
	isOpened: PropTypes.bool,
	quotation: PropTypes.object,
	handleSubmit: PropTypes.func,
	submitting: PropTypes.bool,
	total: PropTypes.number,
	nbPassengers: PropTypes.number,
	updateBooking: PropTypes.func,
	showFlexRatesModal: PropTypes.func,
};

export default memo(FlexRateModal);
